/// <reference types="vite/client" />

import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

// Environment variables - these should be set in .env.local
const supabaseUrl = (import.meta.env?.VITE_SUPABASE_URL as string) || '';
const supabaseAnonKey = (import.meta.env?.VITE_SUPABASE_ANON_KEY as string) || '';

// Check if Supabase is configured
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

// Create client only if configured (graceful degradation to localStorage-only mode)
export const supabase = isSupabaseConfigured
  ? createClient<Database>(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        storage: sessionStorage, // Auth ends with this browser session on shared devices.
        detectSessionInUrl: true,
      },
    })
  : null;

// Helper to check connection status
export async function checkSupabaseConnection(): Promise<boolean> {
  if (!supabase) return false;
  try {
    const { error } = await supabase.from('profiles').select('count').limit(1);
    return !error;
  } catch {
    return false;
  }
}

